import permissionMessages from
  'ringcentral-integration/modules/RolesAndPermissions/permissionsMessages';

export default {
  [permissionMessages.invalidTier]: 'Ihre Edition unterstützt die Integration von {application} nicht. Wenden Sie sich an Ihren Kontoadministrator, um ein Upgrade Ihrer {brand}-Edition durchzuführen.',
};
